import { render, staticRenderFns } from "./cardWorkReport.vue?vue&type=template&id=2774d710&scoped=true&"
import script from "./cardWorkReport.vue?vue&type=script&lang=js&"
export * from "./cardWorkReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2774d710",
  null
  
)

export default component.exports